import { z } from "zod";

export const documentUploadMimeSchema = z.enum([
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/zip",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.oasis.opendocument.text",
  "application/vnd.oasis.opendocument.spreadsheet",
  "application/vnd.oasis.opendocument.presentation",
  "application/rtf",
  "text/plain",
  "text/html",
  "application/epub+zip",
  "application/vnd.amazon.ebook",
  "application/x-mobipocket-ebook",
  "application/x-fictionbook+xml",
  "application/vnd.comicbook+zip",
  "image/png",
  "image/jpeg",
]);

export const createUploadSessionSchema = z.object({
  mime: documentUploadMimeSchema,
  bytes: z.number().int().positive().max(100 * 1024 * 1024),
  checksumSha256: z.string().regex(/^[a-f0-9]{64}$/),
  filename: z.string().trim().min(1).max(255).optional(),
});

export const finalizeUploadSessionSchema = z.object({
  filename: z.string().trim().min(1).max(255).optional(),
  pageCount: z.number().int().positive().max(500).optional(),
  encrypted: z.boolean().optional(),
});

export type CreateUploadSessionRequest = z.infer<typeof createUploadSessionSchema>;
export type FinalizeUploadSessionRequest = z.infer<typeof finalizeUploadSessionSchema>;

